<template>
    <!-- component -->
    <div v-if="categoriesActives.length" class="flex flex-col md:flex-row items-center flex-wrap flex-row">
        <div :id="categorie.id" v-for="categorie in categoriesActives" class="sm:w-full md:w-1/2 lg:w-1/3">
            <inertia-link v-if="categorie.est_visible"
                :href="route('inscription.produits', {'type': type, 'categorie': categorie.slug})"
                class="m-2 card flex flex-col justify-center bg-white rounded-sm shadow-sm hover:shadow-lg">
                <div>
                    <img onerror="this.src='https://via.placeholder.com/400x250/FFFFFF/000000?text=Aucune image trouvée.'"
                        :src="categorie.image ? asset('images/categories/'+categorie.image) : 'https://via.placeholder.com/400x250/FFFFFF/000000?text=Aucune image trouvée.'"
                        class="w-full object-cover object-center h-60"  :alt="categorie.slug"/>
                </div>
                <div class="px-2 py-4 md:h-44 lg:h-32 overflow-hidden overflow-ellipsis">
                    <p class="mb-2 text-xl text-gray-800 font-bold">{{ __(categorie.slug) }}</p>
                    <p class="text-xs" v-html="__(categorie.description)"></p>
                </div>
            </inertia-link>
        </div>
    </div>
    <div v-else class="m-auto md:w-2/4 shadow-md bg-white p-8 rounded-md">
        <p class="font-bold text-center">{{ __('pas_de_categories_disponible') }}</p>
    </div>
</template>

<script>
import App from '@/Layouts/App'

export default {
    name: "Categories",
    layout: App,
    props: {
        categories: Array,
        type: String,
    },
    computed: {
        categoriesActives() {
            return this.categories.filter(categorie => {
                for(let index in categorie.produits) {
                    if(categorie.produits[index].est_visible && (categorie.produits[index].programmes.length || categorie.produits[index].enfants.length || categorie.produits[index].url_redirection))
                        return true;
                }
                return false;
            });
        },
    }
}
</script>

<style scoped>

</style>
